export const stockdata = [
  {
    img: "apple",
    title: "mAAPL",
    subtitle: "Apple Inc.",
    teraprice: "164.92",
    oraprice: "162.72",
    premium: "8.32",
    mincol: "150",
  },
  {
    img: "airbnb",
    title: "mABNB",
    subtitle: "Airbnb Inc.",
    teraprice: "164.92",
    oraprice: "162.72",
    premium: "8.32",
    mincol: "150",
  },
  {
    img: "amd",
    title: "mAMD",
    subtitle: "AMD Inc.",
    teraprice: "164.92",
    oraprice: "162.72",
    premium: "8.32",
    mincol: "150",
  },
  {
    img: "amazon",
    title: "mAMZN",
    subtitle: "Amazon.com Inc.",
    teraprice: "164.92",
    oraprice: "162.72",
    premium: "8.32",
    mincol: "150",
  },
  {
    img: "ark",
    title: "mARKK",
    subtitle: "Ark Innovation ETF",
    teraprice: "164.92",
    oraprice: "162.72",
    premium: "8.32",
    mincol: "150",
  },
  {
    img: "alibaba",
    title: "mBABA",
    subtitle: "Alibaba Holding",
    teraprice: "164.92",
    oraprice: "162.72",
    premium: "8.32",
    mincol: "150",
  },
  {
    img: "bitcoin",
    title: "mBTC",
    subtitle: "Bitcoin",
    teraprice: "164.92",
    oraprice: "162.72",
    premium: "8.32",
    mincol: "150",
  },
  {
    img: "coinbase",
    title: "mCOIN",
    subtitle: "Coinbase Inc.",
    teraprice: "164.92",
    oraprice: "162.72",
    premium: "8.32",
    mincol: "150",
  },
];
